import React, { createContext, useContext, useState } from 'react';

// Create the context
const CarbonFootprintContext = createContext(null);

export const CarbonFootprintProvider = ({ children }) => {
    const [carbonData, setCarbonData] = useState({
        nameOfOrg: '',
        email: '',
        activityType: '',
        Designation: '',
        revenue: 0,
        reportingPeriod: 0,
        selectedFuelTypes: [],
        usedRefrigerants: false,
        selectedRefrigerants: [],
        refrigerantDetails: {},
        fuelDetails: {},
        fuelAmount: 0,
        ghgEmisssion: false,
        GHGtype: [],
        GHGdetails: {},
        aquiredEnergy: 0,
        aquiredRenewable: 0,
        fuelUSedByCompanyVehicles: 0,
        petrol: 0,
        Diesel: 0,
        Metric: '',
        ghgMetric: '',
        familyMembers: 0,
        coal: 0,
        charcoal: 0,
        electricityConsumption: 0,
        renewableElectricity: 0,
        airTravel: 0,
        railTravel: 0,
        mealPreference: '',
        numOfMembers: 0,
        fuelType: '',
        refrigerantType: '',
        refrigerantAmount: 0,
        GeneratorFuel: 0,
        vehicleFuel: 0,
        cabTravel: 0,
        electricCabTravel: 0,
        busTravel: 0,
        electricBusTravel: 0,
        trainTravel: 0,
        metroTravel: 0,
        flightTravel: 0,
        useOfGenerator: false,
        generatorFuelType: '',
        TypeOfVehicle: '',
        ghgemission: false,
        ghgType: '',
        ghgAmount: 0,
        enterpriseElectricityCOnsumption: 0,
        fuElMetric: '',
        renewableElectricityConsumption: 0,
        renewableMetric: '',
        acquiredHeat: 0,
        EnergyMetric: '',
        renewableHeatConsumption: 0,
        renewableHeatMetric: '',
        renewableElectricityPercentage: '',
        acquiredSteam: 0,
        steamMetric: '',
        renewableSteamConsumption: 0,
        renewableSteam: 0,
        renewableSteamMetric: '',
        acquiredCooling: 0,
        coolingMetric: '',
        coolingRenewable: 0,
        renewableCoolingMetric: '',
        generatesRewnewable: false,
        capacityForRenewable: 0,
        metricForRenewable: '',
        tempControl: false,
        consumptionForTempControl: 0,
        lastCalculatedFootprint: 0,
        lastCalculatedDate: '',
        tracksCF: false,
        keyTransportation: [],
        trackEmissionsTransportation: false,
        estimatedEmissionsTransportation: 0,
        businessTravel: {
            flights: 0,
            trains: 0,
            cars: 0,
            cruiseShips: 0,
        },
        primaryComumute: [],
        commuteDetails: {},
        numOfEmployees: 0,
        recycledWaste: 0,
        usesRecycledPlastics: false,
        recyclePercentage: 0,
        managingWastePolicy: false,
        formalSustainabilityPolicy: false,
        assessmentsCF: false,
        ISOstd: '',
        cfOffsetProgram: false,
        hasCertificate: false,
        certificateName: '',
        procurementMechanism: '',
        serialId: '',
        generatorId: '',
        generatorName: '',
        generatorLocation: '',
        generationDate: '',
        issuanceDate: '',
        needsHelpToCalculate: false,
        supplyChainHelpText: '',
    });

    const updateCarbonData = (key, value) => {
        setCarbonData((prev) => ({ ...prev, [key]: value }));
    };

    const resetCarbonData = () => {
        setCarbonData((prev) => ({
            ...prev,
            nameOfOrg: '',
            email: '',
            activityType: '',
            Designation: '',
            revenue: 0,
            reportingPeriod: 0,
            selectedFuelTypes: [],
            fuelDetails: {},
            usedRefrigerants: false,
            selectedRefrigerants: [],
            refrigerantDetails: {},
            ghgEmisssion: false,
            GHGtype: [],
            GHGdetails: {},
            aquiredEnergy: 0,
            aquiredRenewable: 0,
            fuelAmount: 0,
            fuelUSedByCompanyVehicles: 0,
            petrol: 0,
            Diesel: 0,
            Metric: '',
            ghgMetric: '',
            familyMembers: 0,
            coal: 0,
            charcoal: 0,
            electricityConsumption: 0,
            airTravel: 0,
            railTravel: 0,
            mealPreference: '',
            numOfMembers: 0,
            fuelType: '',
            refrigerantType: '',
            refrigerantAmount: 0,
            GeneratorFuel: 0,
            vehicleFuel: 0,
            cabTravel: 0,
            electricCabTravel: 0,
            busTravel: 0,
            electricBusTravel: 0,
            trainTravel: 0,
            metroTravel: 0,
            flightTravel: 0,
            renewableElectricity: 0,
            useOfGenerator: false,
            generatorFuelType: '',
            TypeOfVehicle: '',
            ghgemission: false,
            ghgType: '',
            ghgAmount: 0,
            enterpriseElectricityCOnsumption: 0,
            fuElMetric: '',
            renewableElectricityConsumption: 0,
            renewableMetric: '',
            renewableElectricityPercentage: '',
            acquiredHeat: 0,
            EnergyMetric: '',
            renewableHeatConsumption: 0,
            renewableHeatMetric: '',
            renewableSteamConsumption: 0,
            renewableSteam: 0,
            renewableSteamMetric: '',
            acquiredSteam: 0,
            steamMetric: '',
            acquiredCooling: 0,
            coolingMetric: '',
            coolingRenewable: 0,
            renewableCoolingMetric: '',
            generatesRewnewable: false,
            capacityForRenewable: 0,
            metricForRenewable: '',
            tempControl: false,
            tracksCF: false,
            keyTransportation: [],
            trackEmissionsTransportation: false,
            estimatedEmissionsTransportation: 0,
            businessTravel: {
                flights: 0,
                trains: 0,
                cars: 0,
                cruiseShips: 0,
            },
            primaryComumute: [],
            commuteDetails: {},
            numOfEmployees: 0,
            recycledWaste: 0,
            usesRecycledPlastics: false,
            recyclePercentage: 0,
            managingWastePolicy: false,
            formalSustainabilityPolicy: false,
            assessmentsCF: false,
            ISOstd: '',
            cfOffsetProgram: false,
            hasCertificate: false,
            certificateName: '',
            procurementMechanism: '',
            serialId: '',
            generatorId: '',
            generatorName: '',
            generatorLocation: '',
            generationDate: '',
            issuanceDate: '',
            consumptionForTempControl: 0,
            needsHelpToCalculate: false,
            supplyChainHelpText: '',
            lastCalculatedFootprint: prev.lastCalculatedFootprint,
            lastCalculatedDate: prev.lastCalculatedDate,
        }));
    };

    return (
        <CarbonFootprintContext.Provider value={{ carbonData, updateCarbonData, resetCarbonData }}>
            {children}
        </CarbonFootprintContext.Provider>
    );
};

// Custom hook to use the context
export const useCarbonFootprint = () => {
    const context = useContext(CarbonFootprintContext);
    if (!context) {
        throw new Error('useCarbonFootprint must be used within a CarbonFootprintProvider');
    }
    return context;
};
